<template>
  <div>
    <v-autocomplete
      :value="value"
      :data-cy="dataCy"
      :items="list"
      clearable
      :loading="isLoading"
      :label="label"
      :item-text="userText"
      item-value="id"
      return-object
      disable-filtering
      :rules="rules"
      @input="(v) => $emit('input', v)"
      @update:search-input="(v) => updateUserSearch(v)"
    />
  </div>
</template>

<script>
import { userTable } from '../services/users';

export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: 'User',
    },
    dataCy: {
      type: String,
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      list: [],
      search: '',
      isLoading: false,
    };
  },
  async mounted() {
    await this.updateUserList('');
  },
  methods: {
    userText(val) {
      return `${val.firstName} ${val.lastName} (${val.email})`;
    },
    async updateUserList(search) {
      if (this.isLoading) return;
      this.isLoading = true;
      const { data } = await userTable(search);
      this.list = data?.results;
      this.isLoading = false;
    },
    async updateUserSearch(search) {
      if (!search || search === this.search) return;
      this.search = search || '';
      await this.updateUserList(search?.split(' ')?.[0]);
    },
  },
};
</script>

<style>

</style>
